import { 
  OrderT,
  OrdersStateT,
  OrderStatus,
  RequestStatus,
} from "types";

export const initialOrdersState: OrdersStateT = {
  openOrders: [],
  updatedOrder: null,
  openOrdersStatus: RequestStatus.None,
  closedOrders: [],
  closedOrdersCount: 0,
  closedOrdersStatus: RequestStatus.None,
  createOrderStatus: RequestStatus.Success,
  cancelOrderStatus: RequestStatus.None,
  currentHistoryPage: 1,
}

export const getUpdatedOrders = (list: OrderT[], updatedOrder: OrderT): OrderT[] => {
  let openOrders = [...list];

  const orderToUpdate = openOrders.find(o => o.id === updatedOrder.id);

  if (!orderToUpdate) {
    // if new order
    openOrders.unshift(updatedOrder);
    return openOrders;
  }

  const { id } = orderToUpdate;
  const { status } = updatedOrder;

  if (status === OrderStatus.CompletelyFilled || status === OrderStatus.Canceled) {
    // if remove order
    openOrders = openOrders.filter(o => o.id !== id);
  } else {
    // if update order
    openOrders = openOrders.map(order => {
      if (order.id === updatedOrder.id) {
        return {
          ...updatedOrder,
        };
      }
      return order;
    });
  }

  return openOrders;
};
